import React from "react";
import * as app from "../services/AppService"
import { RowItem } from "../models/Core/row-item";
interface SpanProps extends RowItem {
    children?: any
    class?: string
    isTable?: boolean
    fixed?: boolean
}
export default function Span(props: SpanProps) {//من اجل خاصية اخفاء عمود من الجدول ما تعطي مشكلة 
    return (app.getBoolean(props.hide) ? <></> :
        props.fixed ?
        <span className={(Array.isArray(props.children) ? "row row-md-auto " : "") + props.class}>{Array.isArray(props.children) ? props.children.map((r: any) => {
            return <div className="col col-md-auto d-grid d-md-inline-block">
                {r}
            </div>
        }) : props.children}</span>
            :
            <span className={props.class}>{props.children}</span>
    );
}
